import { useMemo } from 'react';
import { Polyline } from 'react-leaflet';

import { DEFAULT_LINE_COLOR } from './constants';

function catmullRomSpline(points, numPoints = 10) {
  const result = [];

  for (let i = 0; i < points.length - 1; i++) {
    const p0 = points[i - 1] || points[i];
    const p1 = points[i];
    const p2 = points[i + 1];
    const p3 = points[i + 2] || p2;

    for (let t = 0; t < 1; t += 1 / numPoints) {
      const t2 = t * t;
      const t3 = t2 * t;

      const lat =
        0.5 *
        (2 * p1[0] +
          (-p0[0] + p2[0]) * t +
          (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 +
          (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3);

      const lng =
        0.5 *
        (2 * p1[1] +
          (-p0[1] + p2[1]) * t +
          (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 +
          (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3);

      result.push([lat, lng]);
    }
  }

  // Ensure the last point is included
  result.push(points[points.length - 1]);

  return result;
}

function removeConsecutiveDuplicates(arr) {
  return arr.filter((point, index) => {
    if (index === 0) return true;
    const [prevLat, prevLng] = arr[index - 1];
    const [currLat, currLng] = point;
    return prevLat !== currLat || prevLng !== currLng;
  });
}

export default function SmoothPolyline({ color = DEFAULT_LINE_COLOR, positions }) {
  const smoothPositions = useMemo(() => {
    if (positions.length < 3) return positions;

    const coordsWithoutDuplicates = removeConsecutiveDuplicates(positions);

    return catmullRomSpline(coordsWithoutDuplicates, 10); // 10 = smoothness level
  }, [positions]);

  return <Polyline positions={smoothPositions} color={color} />;
}
